(function () {
    'use strict';

    angular
    .module('plagiat2017App')
    .factory('DuplicatesDialogService', DuplicatesDialogService);

    DuplicatesDialogService.$inject = ['DocumentService', 'JsaService', 'ContractService', 'PlagiatValidationService',
                                       '$q', '$translate', '$mdDialog', '$mdToast', '$rootScope'];


    function DuplicatesDialogService(DocumentService, JsaService, ContractService, PlagiatValidationService,
                                     $q, $translate, $mdDialog, $mdToast, $rootScope) {
        var vm = this;
        var service = {
            saveDocumentWithPopUp: saveDocumentWithPopUp,
            saveJSADocumentWithPopUp: saveJSADocumentWithPopUp,
        };

        return service;

        function saveDocumentWithPopUp(obj,ev, callbackFunction) {
            return DocumentService.operator.save(obj).then(function (responseData) {
                var deferred = $q.defer();
                $mdDialog.hide();
                $mdDialog.show(
                    $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("global.messages.info.actionsuccess"))
                        .ariaLabel('')
                        .ok('Ok')
                        .targetEvent(ev)
                );
                ContractService.broadcast();
                $rootScope.$broadcast('on-get-documents');
                if (callbackFunction) {
                    callbackFunction(responseData.data);
                }
                var documentId = responseData.data;
                deferred.resolve(documentId);
                return deferred.promise;
            }, function (errResponse) {
                return $q.reject(errResponse.data);
            }).catch(function (response) {
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }

        function saveJSADocumentWithPopUp(obj, alert) {
            JsaService.saveDocumentJSA(obj).then(function () {
                $mdDialog.hide(alert);
                $mdDialog.show(
                    $mdDialog.confirm()
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant("global.messages.info.actionsuccess"))
                        .ok('Ok')
                );
                ContractService.broadcast();
                $rootScope.$broadcast('on-get-documents');
            }).catch(function (response) {
                $rootScope.$broadcast('on-get-documents');
                $mdDialog.hide(alert);
                vm.isLoading = false;
                PlagiatValidationService.getModalError(response.data);
            });
        }
    }

})();
